import React from 'react';
import { HardDrive, RefreshCw, FileJson } from 'lucide-react';
import { BackupItemRow, BackupFileItem } from './BackupItemRow.js';

interface BackupListSectionProps {
  backups: BackupFileItem[];
  isLoading: boolean;
  isFetching: boolean;
  isDeleting: boolean;
  onRefetch: () => void;
  onInitiateRestore: (filename: string) => void;
  onInitiateDelete: (filename: string) => void;
}

export const BackupListSection: React.FC<BackupListSectionProps> = ({
  backups,
  isLoading,
  isFetching,
  isDeleting,
  onRefetch,
  onInitiateRestore,
  onInitiateDelete,
}) => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-xs overflow-hidden">
      <div className="px-5 py-4 bg-slate-50 border-b border-slate-200 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <HardDrive className="w-4 h-4 text-indigo-600" />
          <h3 className="text-sm font-bold text-slate-800">
            Daftar Snapshot Backup di Server ({backups.length})
          </h3>
        </div>

        <button
          type="button"
          onClick={onRefetch}
          disabled={isFetching}
          className="p-1.5 text-slate-500 hover:text-indigo-600 hover:bg-slate-200/60 rounded-lg transition cursor-pointer"
          title="Segarkan daftar"
        >
          <RefreshCw className={`w-4 h-4 ${isFetching ? 'animate-spin text-indigo-600' : ''}`} />
        </button>
      </div>

      {isLoading ? (
        <div className="p-12 text-center text-slate-500">
          <div className="inline-block w-6 h-6 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin mb-2" />
          <p className="text-xs">Memuat berkas cadangan database...</p>
        </div>
      ) : backups.length === 0 ? (
        <div className="p-10 text-center space-y-3">
          <FileJson className="w-10 h-10 text-slate-300 mx-auto" />
          <h4 className="text-sm font-bold text-slate-700">Belum Ada Berkas Backup</h4>
          <p className="text-xs text-slate-500 max-w-sm mx-auto">
            Klik tombol &quot;Buat Backup Instan&quot; di atas untuk membuat cadangan pangkalan data SQLite UIBN pertama Anda.
          </p>
        </div>
      ) : (
        <div className="divide-y divide-slate-100">
          {backups.map((b) => (
            <BackupItemRow
              key={b.filename}
              backup={b}
              isDeleting={isDeleting}
              onInitiateRestore={onInitiateRestore}
              onInitiateDelete={onInitiateDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
};
